import styled from 'styled-components';
import { Button } from '@common/components/Button';
import { media } from 'styled-bootstrap-grid';

export const SignInSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 20px;
  line-height: 1.5;
  border-radius: 3px;
  position: sticky;
  border-bottom: 6px solid ${({ theme }) => theme.customColors.borderGreyLighter};

  ${media.md`
    margin-top: 20px;
    padding: 36px 30px;
    border: ${({ theme }) => `1px solid ${(theme as any).customColors.borderGreyLighter}`};
  `}
`;

export const SignInDescription = styled.div`
  display: none;
  margin-bottom: 24px;
  font-size: 16px;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
  font-weight: ${({ theme }) => theme.fontWeights.normal};

  ${media.md`
    display: flex;
  `}
`;

export const StyledButton = styled(Button)`
  display: none;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.customColors.primary};
  color: white;
  height: 46px;
  letter-spacing: 0px;
  width: 100%;
  font-size: 16px;

  ${media.md`
    display: flex;
  `}
`;

export const SignInDescriptionMobile = styled(SignInDescription)`
  font-size: 15px;
  display: flex;
  margin-bottom: 0px;
  color: ${({ theme }) => theme.defaultColors.fontPrimary};

  ${media.md`
    display: none;
  `}
`;

export const StyledAnchor = styled.a`
  text-decoration: underline;
  padding-left: 3px;
  cursor: pointer;
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
`;
